import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useColorMode } from '@chakra-ui/react';
import { theme } from '../../modules/theme';
import { Typography } from '../Typography';
export const NumberedAccordionNumber = forwardRef(({ variant, size, children, ...otherProps }, ref) => {
    const { colorMode } = useColorMode();
    return (_jsx(Typography, { ref: ref, as: "div", variant: "heading", size: { base: 'xs', md: 'sm' }, fontWeight: "500", color: theme.colors[colorMode].text.tertiary, textAlign: "left", w: { base: theme.sizes['10'], md: theme.sizes['12'] }, flexShrink: 0, ...otherProps, children: typeof children === 'number' ? `${children}`.padStart(2, '0') : children }));
});
